/* Felmiro — extras (21-09-2026): pago por transferencia/tarjeta en el carrito, antes/después,
   oferta con cuenta regresiva, botones flotantes (WhatsApp + asistente 24/7).
   Se carga UNA sola vez desde layout/theme.liquid. Todo con prefijo fx- para no chocar con el tema. */
(() => {
  if (window.__fxExtras) return;
  window.__fxExtras = true;

  const reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------- Pago: transferencia (5% OFF) o tarjeta ---------------- */
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-fx-metodo]');
    if (!btn) return;
    const caja = btn.closest('[data-fx-pago]');
    if (!caja || btn.disabled) return;
    e.preventDefault();
    const metodo = btn.dataset.fxMetodo;
    const codigo = caja.dataset.codigo || 'TRANSFERENCIA5';
    const checkout = caja.dataset.checkout || '/checkout';
    const error = caja.querySelector('.fx-pago__error');
    caja.querySelectorAll('[data-fx-metodo]').forEach((b) => { b.disabled = true; });
    btn.classList.add('is-cargando');
    if (error) error.hidden = true;

    const esTransf = metodo === 'transferencia';
    const cuerpo = {
      discount: esTransf ? codigo : '',
      attributes: { 'Método de pago elegido': esTransf ? 'Transferencia bancaria (5% OFF)' : 'Tarjeta' },
    };
    // Si hay una nota del carrito sin guardar, la mandamos también.
    const nota = document.querySelector('#CartDrawer-Note, #Cart-note');
    if (nota) cuerpo.note = nota.value;
    try {
      await fetch(caja.dataset.cartUpdate || '/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(cuerpo),
      });
    } catch (_) { /* el parámetro de la URL aplica el código igual */ }
    window.location.href = esTransf ? `${checkout}?discount=${encodeURIComponent(codigo)}` : checkout;
    // Si el navegador vuelve con "atrás", los botones quedan usables.
    setTimeout(() => {
      caja.querySelectorAll('[data-fx-metodo]').forEach((b) => { b.disabled = false; });
      btn.classList.remove('is-cargando');
    }, 6000);
  });
  window.addEventListener('pageshow', (ev) => {
    if (!ev.persisted) return;
    document.querySelectorAll('[data-fx-metodo]').forEach((b) => { b.disabled = false; b.classList.remove('is-cargando'); });
  });

  /* ---------------- Antes / Después ---------------- */
  function initAntesDespues(marco) {
    if (marco.__fx) return;
    marco.__fx = true;
    const mango = marco.querySelector('.fx-ad__mango');
    let pos = Number(marco.dataset.inicio) || 50;
    let arrastrando = false;
    let pendiente = null;
    let tocado = false;

    const pintar = (p) => {
      pos = Math.min(100, Math.max(0, p));
      marco.style.setProperty('--fx-pos', `${pos}%`);
      if (mango) {
        mango.setAttribute('aria-valuenow', String(Math.round(pos)));
        mango.setAttribute('aria-valuetext', `${Math.round(pos)}% antes`);
      }
    };
    const desdeX = (clientX) => {
      const r = marco.getBoundingClientRect();
      return ((clientX - r.left) / r.width) * 100;
    };
    const programar = (p) => {
      pendiente = p;
      if (marco.__raf) return;
      marco.__raf = requestAnimationFrame(() => { marco.__raf = 0; if (pendiente !== null) pintar(pendiente); });
    };

    marco.addEventListener('pointerdown', (e) => {
      if (e.button !== undefined && e.button !== 0) return;
      tocado = true;
      arrastrando = true;
      marco.classList.add('is-arrastrando');
      // Con mouse y lápiz capturamos siempre. Con el dedo, solo si el gesto es horizontal (ver pointermove).
      if (e.pointerType !== 'touch') marco.setPointerCapture?.(e.pointerId);
      marco.__x0 = e.clientX; marco.__y0 = e.clientY; marco.__dir = e.pointerType === 'touch' ? null : 'h';
      if (e.pointerType !== 'touch') programar(desdeX(e.clientX));
    });
    marco.addEventListener('pointermove', (e) => {
      if (!arrastrando) return;
      if (marco.__dir === null) {
        const dx = Math.abs(e.clientX - marco.__x0), dy = Math.abs(e.clientY - marco.__y0);
        if (dx < 4 && dy < 4) return;
        marco.__dir = dx > dy ? 'h' : 'v';
        if (marco.__dir === 'v') { arrastrando = false; marco.classList.remove('is-arrastrando'); return; }
        marco.setPointerCapture?.(e.pointerId);
      }
      programar(desdeX(e.clientX));
    });
    const soltar = (e) => {
      if (arrastrando && marco.__dir === null && e.type === 'pointerup') programar(desdeX(e.clientX)); // tap
      arrastrando = false;
      marco.classList.remove('is-arrastrando');
    };
    marco.addEventListener('pointerup', soltar);
    marco.addEventListener('pointercancel', soltar);
    marco.addEventListener('dragstart', (e) => e.preventDefault());

    mango?.addEventListener('keydown', (e) => {
      const paso = e.shiftKey ? 10 : 2;
      let n = null;
      if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') n = pos - paso;
      else if (e.key === 'ArrowRight' || e.key === 'ArrowUp') n = pos + paso;
      else if (e.key === 'Home') n = 0;
      else if (e.key === 'End') n = 100;
      if (n === null) return;
      e.preventDefault();
      tocado = true;
      pintar(n);
    });

    // Pista: al aparecer, la línea se mueve sola una vez para mostrar que se puede arrastrar.
    if (marco.dataset.pista === 'true' && !reducido && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver((ents) => {
        if (!ents.some((x) => x.isIntersecting)) return;
        io.disconnect();
        const base = pos;
        const t0 = performance.now();
        const dur = 1800;
        const paso = (t) => {
          if (tocado) return;
          const k = Math.min(1, (t - t0) / dur);
          const onda = Math.sin(k * Math.PI * 2) * 14 * (1 - k);
          pintar(base + onda);
          if (k < 1) requestAnimationFrame(paso);
          else pintar(base);
        };
        setTimeout(() => requestAnimationFrame(paso), 350);
      }, { threshold: 0.55 });
      io.observe(marco);
    }
    pintar(pos);
  }

  /* ---------------- Oferta: cuenta regresiva hasta la medianoche ---------------- */
  const relojes = new Set();
  let intervalo = 0;
  const dos = (n) => String(n).padStart(2, '0');
  function tic() {
    const ahora = new Date();
    const fin = new Date(ahora); fin.setHours(24, 0, 0, 0);
    let s = Math.max(0, Math.floor((fin - ahora) / 1000));
    const txt = `${dos(Math.floor(s / 3600))}:${dos(Math.floor((s % 3600) / 60))}:${dos(s % 60)}`;
    relojes.forEach((el) => { if (el.isConnected) el.textContent = txt; else relojes.delete(el); });
  }
  function initOferta(el) {
    const r = el.querySelector('[data-fx-reloj]');
    if (!r || relojes.has(r)) return;
    relojes.add(r);
    tic();
    if (!intervalo) intervalo = setInterval(tic, 1000);
  }

  /* ---------------- Botones flotantes y asistente ---------------- */
  const sinTildes = (t) => t.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9ñ\s]/g, ' ');

  /* Base de respuestas de la boquilla antirronquidos (tema bq). Solo datos verificados:
     ficha del proveedor (Dropi), caja del fabricante, políticas publicadas y configuración de Shopify. */
  function baseBoquilla(d) {
    const verProducto = { texto: 'Ver la boquilla', url: d.url };
    return [
      { c: ['hola', 'buenas', 'buen dia', 'buenas tardes', 'buenas noches', 'que tal', 'hey'], peso: 0.5,
        r: '¡Hola! 😊 Contame qué querés saber: cómo funciona, cómo se moldea, envíos, pagos o devoluciones.' },
      { c: ['gracias', 'genial', 'perfecto', 'buenisimo', 'joya', 'dale'], peso: 0.5,
        r: '¡De nada! Si te queda alguna otra duda, acá estoy. 🙌' },
      { c: ['envio', 'envios', 'enviar', 'envian', 'llega', 'llegar', 'tarda', 'demora', 'dias', 'correo', 'despacho', 'despachan', 'pais', 'argentina', 'provincia'],
        r: `🚚 El envío es gratis a todo el país y te pasamos el número de seguimiento cuando sale. ${d.plazo ? 'Plazo de entrega: ' + d.plazo + '.' : ''}` },
      { c: ['transferencia', 'transferir', 'transfiero', 'alias', 'cbu', 'cvu', 'deposito', 'comprobante'], peso: 1.3,
        r: '🏦 Pagando por transferencia tenés 5% OFF. En el carrito tocá «TRANSFERENCIA (5% OFF)» y el descuento se aplica solo. En el checkout elegí «Transferencia bancaria» y al confirmar te aparecen los datos. Después mandanos el comprobante por WhatsApp.', wa: true },
      { c: ['pago', 'pagar', 'pagos', 'tarjeta', 'tarjetas', 'credito', 'debito', 'cuotas', 'mercado pago', 'mercadopago', 'medios', 'efectivo'],
        r: '💳 Podés pagar con Mercado Pago (tarjeta de crédito o débito y dinero en cuenta) o por transferencia con 5% OFF. ' + (d.cuotasSinInteres ? 'Con tarjeta de crédito tenés ' + d.cuotasSinInteres + ' cuotas sin interés.' : 'Las cuotas disponibles y su costo te los muestra Mercado Pago al pagar.') + ' El pago se hace en el checkout seguro de Shopify.' },
      { c: ['precio', 'cuesta', 'cuanto sale', 'cuanto vale', 'valor', 'sale', 'costo'],
        r: `💰 La boquilla cuesta ${d.precio}, con envío gratis. Llevando 2 pagás ${d.pack || 'menos por unidad'} (el descuento se aplica solo en el carrito).`, acciones: [verProducto] },
      { c: ['pack', 'packs', 'dos', '2', 'pareja', 'para los dos', 'repuesto', 'descuento', 'oferta', 'promo', 'cupon', 'codigo'],
        r: `🎁 El pack de 2 sale ${d.pack || 'menos por unidad'}: sirve si roncan los dos o para tener una de repuesto. Cada persona moldea la suya, no se comparte.`, acciones: [verProducto] },
      { c: ['devolucion', 'devolver', 'devuelvo', 'cambio', 'cambiar', 'reembolso', 'garantia', 'garantía', 'falla', 'fallas', 'roto', 'rota', 'danado', 'defecto', 'arrepentimiento', 'arrepentir', '30 dias', 'no me sirve', 'no me gusta'],
        r: `🛡️ Tenés garantía de 30 días desde que la recibís: si llega dañada, incompleta o con una falla, o se rompe con el uso normal, te la cambiamos sin cargo; y si cambiás de idea, te devolvemos el dinero con la boquilla sin moldear ni usar y en su caja. Además tenés el botón de arrepentimiento (10 días) y la garantía legal de 6 meses por fallas. Escribinos a ${d.email} o por WhatsApp.`, wa: true, acciones: [{ texto: 'Ver condiciones', url: '/pages/garantia' }] },
      { c: ['funciona', 'como funciona', 'para que sirve', 'mandibula', 'avance', 'mecanismo', 'que hace'],
        r: '😴 Es una boquilla de avance mandibular: dos piezas que se encastran y llevan la mandíbula unos milímetros hacia adelante mientras dormís, para dejarle más lugar al aire. Está pensada para el ronquido que aparece cuando la mandíbula se va hacia atrás al dormir.', acciones: [verProducto] },
      { c: ['sirve', 'funcionara', 'resultado', 'resultados', 'efectiva', 'efectivo', 'cura', 'curar', 'deja de roncar', 'garantizado'],
        r: 'Te somos honestos: no a todos les funciona igual, porque el ronquido tiene distintas causas (por ejemplo, si viene de la nariz tapada puede no ayudar). Por eso no prometemos resultados. Si roncás muy fuerte o hacés pausas al respirar, consultalo con un médico.' },
      { c: ['moldear', 'moldeo', 'molde', 'agua caliente', 'hervir', 'como se usa', 'usar', 'uso', 'instrucciones', 'manual', 'paso', 'pasos', 'ajustar', 'regular', 'posiciones'],
        r: '🔥 Se ablanda con agua caliente y se adapta mordiéndola, siguiendo los tiempos del manual de la caja (con cuidado para no quemarte). Después elegís cuánto avanza: según el proveedor tiene 10 posiciones de 1 mm. Arrancá por la más suave.', acciones: [verProducto] },
      { c: ['duele', 'dolor', 'molesta', 'molestia', 'saliva', 'babeo', 'mandibula cargada', 'incomoda', 'acostumbrar'],
        r: 'Las primeras noches es habitual sentir la mandíbula o los dientes un poco cargados o tener más saliva. Volvé a un nivel más suave y subí de a uno. Si la molestia sigue, dejá de usarla y consultá a tu odontólogo.' },
      { c: ['apnea', 'medico', 'doctor', 'cpap', 'ahogo', 'pausas', 'tratamiento'],
        r: '👩‍⚕️ No es un tratamiento médico ni reemplaza el de la apnea del sueño. Si te dijeron que hacés pausas al respirar, te despertás ahogado o tenés mucho sueño de día, consultalo con un médico antes de usarla.' },
      { c: ['ortodoncia', 'brackets', 'implante', 'implantes', 'protesis', 'dentadura', 'dientes flojos', 'atm', 'articulacion', 'menor', 'menores', 'nino', 'ninos', 'edad', 'embarazo'],
        r: 'En ese caso consultalo antes con tu odontólogo: con dientes flojos, prótesis, ortodoncia o problemas en la articulación de la mandíbula no la recomendamos sin su OK. Tampoco es para menores de 18 años.' },
      { c: ['caja', 'incluye', 'trae', 'viene', 'contenido', 'estuche'],
        r: '📦 Trae la boquilla (dos piezas encastrables), un estuche para guardarla y el manual de instrucciones.' },
      { c: ['limpiar', 'limpieza', 'lavar', 'higiene', 'jabon'],
        r: '💧 Lavala con agua tibia y jabón neutro después de cada uso, dejala secar y guardala en su estuche.' },
      { c: ['mi pedido', 'pedido', 'seguimiento', 'tracking', 'donde esta', 'no llego', 'orden'],
        r: `📍 Cuando despachamos te llega el código de seguimiento por email. Si no lo encontrás o tu pedido se demora, escribinos por WhatsApp o a ${d.email} con tu número de pedido.`, wa: true },
      { c: ['humano', 'persona', 'asesor', 'hablar', 'whatsapp', 'wsp', 'contacto', 'contactar', 'telefono', 'email', 'mail'],
        r: `Claro 🙂 Te atiende una persona del equipo por WhatsApp, o escribinos a ${d.email}.`, wa: true },
      { c: ['comprar', 'compro', 'quiero', 'carrito', 'agregar', 'la llevo'],
        r: '¡Genial! 🙌 Elegí si querés 1 o el pack x2 en la página de la boquilla y agregala al carrito. Ahí elegís pagar con tarjeta o por transferencia con 5% OFF.', acciones: [verProducto] },
    ];
  }

  function baseConocimiento(d) {
    if (d.modo === 'boquilla') return baseBoquilla(d);
    const verProducto = { texto: 'Ver el limpiador', url: d.url };
    const precio = d.precioAntes ? `${d.precio} (antes ${d.precioAntes})` : d.precio;
    return [
      { c: ['hola', 'buenas', 'buen dia', 'buenas tardes', 'buenas noches', 'que tal', 'hey'], peso: 0.5,
        r: '¡Hola! 😊 Contame qué querés saber: envíos, formas de pago, cómo se usa, qué trae la caja o devoluciones.' },
      { c: ['gracias', 'genial', 'perfecto', 'buenisimo', 'joya', 'dale'], peso: 0.5,
        r: '¡De nada! Si te queda alguna otra duda, acá estoy las 24 horas. 🙌' },
      { c: ['envio', 'envios', 'enviar', 'envian', 'llega', 'llegar', 'tarda', 'demora', 'dias', 'correo', 'despacho', 'despachan', 'pais', 'paises', 'mexico', 'chile', 'colombia', 'peru', 'estados unidos', 'argentina'],
        r: '🚚 El envío es GRATIS en todos los pedidos, sin monto mínimo y con número de seguimiento. Despachamos en 1 a 3 días hábiles y te mandamos el código por email. Plazo estimado desde la compra: 12 a 25 días corridos, a todo el país.' },
      { c: ['transferencia', 'transferir', 'transfiero', 'alias', 'cbu', 'cvu', 'deposito', 'comprobante', 'mercado pago transferencia'], peso: 1.3,
        r: '🏦 Pagando por transferencia tenés 5% OFF extra. En el carrito tocá «TRANSFERENCIA (5% OFF)»: el descuento ya se aplica solo. En el checkout elegí «Transferencia bancaria» y al confirmar el pedido te aparecen los datos (banco, titular, alias y CUIT). Después mandanos el comprobante por WhatsApp y despachamos apenas se acredita.',
        wa: true },
      { c: ['pago', 'pagar', 'pagos', 'tarjeta', 'tarjetas', 'credito', 'debito', 'cuotas', 'mercado pago', 'mercadopago', 'paypal', 'visa', 'mastercard', 'efectivo', 'medios'],
        r: '💳 Podés pagar con tarjeta de crédito o débito (Visa, Mastercard, American Express, Diners, Maestro) por Mercado Pago, con PayPal, o por transferencia con 5% OFF. El pago se hace en el checkout seguro de Shopify: nosotros nunca vemos los datos de tu tarjeta. Las cuotas disponibles las muestra Mercado Pago al pagar.' },
      { c: ['precio', 'cuesta', 'cuanto sale', 'cuanto vale', 'valor', 'sale', 'costo', 'barato'],
        r: `💰 El limpiador cuesta ${precio}, con envío gratis. Llevando 2 tenés 10% OFF en los dos y llevando 3, 20% OFF. Y si pagás por transferencia, 5% OFF extra.`, acciones: [verProducto] },
      { c: ['pack', 'packs', 'descuento', 'descuentos', 'oferta', 'promo', 'promocion', 'cupon', 'codigo', 'dos', 'tres', '2', '3', 'pareja', 'familia'],
        r: '🎁 Llevando 2 unidades tenés 10% OFF en las dos, y llevando 3, 20% OFF (se aplica solo en el carrito). Además, si pagás por transferencia sumás 5% OFF extra sobre el total.', acciones: [verProducto] },
      { c: ['devolucion', 'devolver', 'devuelvo', 'cambio', 'cambiar', 'reembolso', 'garantia', 'falla', 'fallas', 'roto', 'rota', 'dañado', 'danado', 'defecto', 'arrepentimiento', 'arrepentir', 'no me gusta'],
        r: `🔄 Tenés cambios y devoluciones GRATIS hasta 30 días desde que lo recibís. Si llega dañado o con fallas, escribinos a ${d.email} o por WhatsApp y lo resolvemos. En Argentina además tenés el botón de arrepentimiento (10 días corridos).`, wa: true },
      { c: ['usar', 'uso', 'usa', 'como funciona', 'funciona', 'como se', 'modo', 'modos', 'intensidad', 'instrucciones', 'manual', 'paso', 'pasos', 'frecuencia', 'cada cuanto', 'minutos'],
        r: '🦷 Empezá siempre en la intensidad más baja. Apoyá la punta sobre el diente (nunca sobre la encía ni por debajo), y movela suave sin quedarte en un mismo punto. Es para el mantenimiento en casa entre limpiezas profesionales. En la página del producto tenés la guía de uso seguro completa en español.', acciones: [verProducto] },
      { c: ['esmalte', 'daña', 'dana', 'dañar', 'lastima', 'lastimar', 'seguro', 'segura', 'duele', 'dolor', 'encia', 'encias', 'sangra', 'sensible', 'sensibilidad', 'peligroso'],
        r: '✅ Usado como indica la guía no debería dañar el esmalte: intensidad baja al principio, solo sobre el diente y nunca sobre la encía. Si tenés encías inflamadas o dientes sensibles, consultalo antes con tu odontólogo.' },
      { c: ['ortodoncia', 'brackets', 'bracket', 'implante', 'implantes', 'protesis', 'corona', 'carillas', 'embarazada', 'embarazo', 'corazon', 'cardiaco', 'marcapasos', 'niño', 'niños', 'chico', 'chicos', 'edad'],
        r: '👩‍⚕️ En ese caso te pedimos que lo consultes antes con tu odontólogo: con ortodoncia, implantes, prótesis, problemas cardíacos o encías inflamadas es lo más seguro. Si te da el OK, se usa igual que siempre, en intensidad baja.' },
      { c: ['dentista', 'odontologo', 'reemplaza', 'reemplazar', 'limpieza profesional', 'consultorio'],
        r: 'No reemplaza la limpieza del dentista 🙂 Felmiro es para el mantenimiento en casa entre una limpieza profesional y la siguiente. Seguí con tus controles habituales.' },
      { c: ['sarro', 'placa', 'mancha', 'manchas', 'amarillo', 'amarillos', 'blanquea', 'blanqueamiento', 'blanco', 'resultado', 'resultados', 'sirve', 'efectivo', 'antes y despues'],
        r: '✨ Vibra a alta frecuencia para aflojar manchas y placa visible sobre la superficie del diente, con intensidad regulable y cabezales intercambiables. No es un blanqueador: deja los dientes más limpios. Los resultados dependen de cada persona y de la constancia de uso.', acciones: [verProducto] },
      { c: ['caja', 'incluye', 'trae', 'viene', 'contenido', 'cabezal', 'cabezales', 'repuesto', 'repuestos', 'espejo', 'accesorios', 'cable'],
        r: '📦 En la caja viene: 1 limpiador dental eléctrico recargable, cabezales intercambiables, 1 espejo bucal y 1 cable de carga USB-C, más el manual del fabricante.' },
      { c: ['bateria', 'carga', 'cargar', 'cargador', 'usb', 'usb c', 'dura', 'duracion', 'autonomia', 'pilas', 'recargable'],
        r: '🔋 Se carga con el cable USB-C incluido (sin pilas). Con unas 2 horas de carga tenés autonomía para varias sesiones.' },
      { c: ['agua', 'mojar', 'moja', 'ducha', 'impermeable', 'ipx6', 'lavar', 'limpiar'],
        r: '💧 Es resistente al agua (IPX6): lo podés enjuagar sin problema. No lo sumerjas ni lo dejes en remojo.' },
      { c: ['color', 'colores', 'negro', 'blanco', 'modelo', 'modelos'],
        r: 'Lo tenemos en Blanco y en Negro. Elegís el color en la página del producto antes de agregarlo al carrito.', acciones: [verProducto] },
      { c: ['moneda', 'dolar', 'dolares', 'usd', 'pesos', 'ars', 'cambio de moneda', 'impuestos'],
        r: 'El precio ya está en pesos argentinos (ARS), con impuestos incluidos. Pagás exactamente el monto que ves en la página, sin conversiones ni sorpresas en el checkout.' },
      { c: ['mi pedido', 'pedido', 'seguimiento', 'tracking', 'donde esta', 'no llego', 'numero de seguimiento', 'orden'],
        r: `📍 Cuando despachamos te llega el código de seguimiento por email. Si no lo encontrás (revisá spam) o tu pedido se demora, escribinos por WhatsApp o a ${d.email} con tu número de pedido y lo revisamos.`, wa: true },
      { c: ['humano', 'persona', 'asesor', 'hablar', 'whatsapp', 'wsp', 'contacto', 'contactar', 'telefono', 'llamar', 'email', 'mail'],
        r: `Claro 🙂 Te atiende una persona del equipo por WhatsApp, o escribinos a ${d.email}.`, wa: true },
      { c: ['comprar', 'compro', 'quiero', 'carrito', 'agregar', 'lo llevo'],
        r: '¡Genial! 🙌 Elegí color y cantidad en la página del producto y agregalo al carrito. Ahí vas a ver las dos opciones de pago: transferencia con 5% OFF o tarjeta.', acciones: [verProducto] },
    ];
  }

  function responderLocal(base, pregunta) {
    const q = ` ${sinTildes(pregunta).replace(/\s+/g, ' ').trim()} `;
    let mejor = null, puntos = 0;
    for (const it of base) {
      let p = 0;
      for (const c of it.c) {
        const k = sinTildes(c).trim();
        if (!k) continue;
        if (k.length <= 2) { if (q.includes(` ${k} `)) p += 0.4; continue; }
        if (q.includes(` ${k}`)) p += k.includes(' ') ? 2 : 1;
      }
      p *= it.peso || 1;
      if (p > puntos) { puntos = p; mejor = it; }
    }
    return puntos >= 0.5 ? mejor : null;
  }

  function initFlotantes(raiz) {
    if (raiz.__fx) return;
    raiz.__fx = true;
    const chat = raiz.querySelector('[data-fx-chat]');
    const abrir = raiz.querySelector('[data-fx-chat-abrir]');
    const burbuja = raiz.querySelector('[data-fx-burbuja]');

    // Subir los botones cuando la barra fija de compra está visible abajo.
    const ajustar = () => {
      const barra = document.querySelector('marca-barra.is-visible');
      let extra = 0;
      if (barra) {
        const r = barra.getBoundingClientRect();
        if (r.bottom >= window.innerHeight - 2 && r.height < window.innerHeight / 2) extra = r.height;
      }
      raiz.style.setProperty('--fx-flot-extra', `${extra}px`);
    };
    let pend = false;
    const alScroll = () => { if (pend) return; pend = true; requestAnimationFrame(() => { pend = false; ajustar(); }); };
    window.addEventListener('scroll', alScroll, { passive: true });
    window.addEventListener('resize', alScroll);
    setInterval(ajustar, 1500);
    ajustar();

    if (!chat || !abrir) return;
    let datos = {};
    try { datos = JSON.parse(chat.querySelector('[data-fx-chat-datos]').textContent); } catch (_) {}
    const base = baseConocimiento(datos);
    const log = chat.querySelector('[data-fx-chat-log]');
    const chips = chat.querySelector('[data-fx-chat-chips]');
    const form = chat.querySelector('[data-fx-chat-form]');
    const input = form.querySelector('input');
    const wa = chat.dataset.wa;
    const endpoint = chat.dataset.endpoint;
    const historial = [];
    let iniciado = false;

    const linkWa = (texto) => `https://wa.me/${wa}?text=${encodeURIComponent(texto)}`;
    const burbujaMsg = (quien, html, acciones) => {
      const m = document.createElement('div');
      m.className = `fx-chat__msg fx-chat__msg--${quien}`;
      const p = document.createElement('p');
      if (quien === 'yo') p.textContent = html; else p.innerHTML = html;
      m.appendChild(p);
      if (acciones && acciones.length) {
        const fila = document.createElement('div');
        fila.className = 'fx-chat__acciones';
        acciones.forEach((a) => {
          const el = document.createElement('a');
          el.className = `fx-chat__accion${a.wa ? ' fx-chat__accion--wa' : ''}`;
          el.href = a.url;
          el.textContent = a.texto;
          if (a.externo) { el.target = '_blank'; el.rel = 'noopener'; }
          fila.appendChild(el);
        });
        m.appendChild(fila);
      }
      log.appendChild(m);
      log.scrollTop = log.scrollHeight;
      return m;
    };
    const escribiendo = () => {
      const m = document.createElement('div');
      m.className = 'fx-chat__msg fx-chat__msg--bot fx-chat__msg--escribiendo';
      m.innerHTML = '<p><span></span><span></span><span></span></p>';
      m.setAttribute('aria-label', 'Escribiendo');
      log.appendChild(m);
      log.scrollTop = log.scrollHeight;
      return m;
    };
    const escapar = (t) => t.replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

    const pintarChips = () => {
      chips.innerHTML = '';
      (datos.chips || []).forEach((t) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'fx-chat__chip';
        b.textContent = t;
        b.addEventListener('click', () => preguntar(t));
        chips.appendChild(b);
      });
    };

    async function consultarIA(pregunta) {
      if (!endpoint) return null;
      const ctrl = new AbortController();
      const t = setTimeout(() => ctrl.abort(), 9000);
      try {
        const r = await fetch(endpoint, {
          method: 'POST', signal: ctrl.signal,
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ pregunta, historial: historial.slice(-8), contexto: { tienda: 'Felmiro', pagina: location.pathname } }),
        });
        const j = await r.json();
        return (j && (j.respuesta || j.reply)) || null;
      } catch (_) { return null; } finally { clearTimeout(t); }
    }

    async function preguntar(texto) {
      const q = texto.trim();
      if (!q) return;
      burbujaMsg('yo', q);
      historial.push({ rol: 'cliente', texto: q });
      const esp = escribiendo();
      const t0 = Date.now();
      let resp = await consultarIA(q);
      let acciones = [];
      if (!resp) {
        const it = responderLocal(base, q);
        if (it) {
          resp = escapar(it.r);
          acciones = (it.acciones || []).slice();
          if (it.wa && wa) acciones.push({ texto: 'Escribir por WhatsApp', url: linkWa(`Hola Felmiro! ${q}`), externo: true, wa: true });
        } else {
          resp = escapar(datos.noSe || 'Esa no la sé. Escribinos por WhatsApp.');
          if (wa) acciones.push({ texto: 'Preguntar por WhatsApp', url: linkWa(`Hola Felmiro! ${q}`), externo: true, wa: true });
        }
      } else {
        resp = escapar(resp).replace(/\n/g, '<br>');
      }
      const espera = Math.max(0, 650 - (Date.now() - t0));
      setTimeout(() => {
        esp.remove();
        burbujaMsg('bot', resp, acciones);
        historial.push({ rol: 'asistente', texto: resp });
      }, reducido ? 0 : espera);
    }

    const setAbierto = (si) => {
      chat.hidden = !si;
      raiz.classList.toggle('is-chat-abierto', si);
      abrir.setAttribute('aria-expanded', String(si));
      if (burbuja) burbuja.hidden = true;
      if (si && !iniciado) {
        iniciado = true;
        burbujaMsg('bot', escapar(datos.saludo || '¡Hola! ¿En qué te ayudo?'));
        pintarChips();
      }
      if (si && window.matchMedia('(min-width: 750px)').matches) setTimeout(() => input.focus(), 50);
    };
    abrir.addEventListener('click', () => setAbierto(chat.hidden));
    chat.querySelector('[data-fx-chat-cerrar]').addEventListener('click', () => { setAbierto(false); abrir.focus(); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !chat.hidden) setAbierto(false); });
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const v = input.value;
      input.value = '';
      preguntar(v);
    });

    if (burbuja) {
      let visto = false;
      try { visto = sessionStorage.getItem('fx-burbuja') === '1'; } catch (_) {}
      if (!visto) {
        setTimeout(() => {
          if (!chat.hidden) return;
          burbuja.hidden = false;
          try { sessionStorage.setItem('fx-burbuja', '1'); } catch (_) {}
          setTimeout(() => { burbuja.hidden = true; }, 9000);
        }, 7000);
      }
    }
  }

  /* ---------------- Arranque ---------------- */
  function init(raiz = document) {
    raiz.querySelectorAll('[data-fx-ad]').forEach(initAntesDespues);
    raiz.querySelectorAll('[data-fx-oferta]').forEach(initOferta);
    raiz.querySelectorAll('[data-fx-flot]').forEach(initFlotantes);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  // Editor de temas y re-render de secciones (Dawn reemplaza el HTML del formulario de producto).
  document.addEventListener('shopify:section:load', (e) => init(e.target));
  let mo = 0;
  new MutationObserver(() => {
    if (mo) return;
    mo = requestAnimationFrame(() => { mo = 0; init(); });
  }).observe(document.body || document.documentElement, { childList: true, subtree: true });
})();
